<template lang="pug">
#search.deals-search(style="flex-grow: 3")
  .sort
    md-field(md-theme="white" class="deals-search__year")
      z-select(v-model="year" v-on:change="changeDealYearFilter")
        option(value="all" disabled) Год
        option(v-for="year in years" v-bind:value="year" v-bind:key="`deals-filter-item-${year}`") {{ year }}
  .sort
    md-field(md-theme="white")
      z-select(v-model="status" v-on:change="changeStatusFilter")
        option(value="all") Статус трекинга (любой)
        option(v-for="status in freightStatuses" v-bind:value="status.id" v-bind:key="status.id") {{ status.name }}
  .sort
    md-field(md-theme="white")
      z-select(v-model="dealStatus" v-on:change="changeDealStatusFilter")
        option(value="all") Статус заявки (любой)
        option(v-for="status in dealStatuses" v-bind:value="status.id" v-bind:key="status.id") {{ status.name }}

        
  //md-icon add
  input.text(type="text" placeholder="Введите номер заявки для поиска" v-model="searchString" v-on:keyup="dropdown" v-on:keyup.enter="filter")
  md-button.button-close.small.md-icon-button.md-accent(@click="resetFilter" v-if="searchString.length || hasCustomFilter")
    md-icon close
  md-button.button-close.small.md-icon-button.md-primary(@click="filter" v-if="searchString.length")
    md-icon search    
  md-button.md-icon-button.md-dense.md-primary(v-on:click="toggleFilterSettings")
      md-icon settings
  .dropdown.md-elevation-2(v-if="filterSettings" v-click-outside="hideFilterSettings")
    .search-md-menu-container.deals-search-setting.can-scroll
      .md-layout.filter-container




        // Дата

        .md-layout-item.md-size-20.center-layout
          label Дата создания
        .md-layout-item.md-size-40.with-pr.center-layout
          z-date(label="" placeholder="От" v-model="date.from" no-margin)
        .md-layout-item.md-size-40.center-layout
          z-date(label="" placeholder="До" v-model="date.to" no-margin)


        // Тип перевозки

        .md-layout-item.md-size-20.center-layout
          label Тип перевозки
        .md-layout-item.md-size-40.with-pr.center-layout
          z-select(v-model="forwardType.from" name="forwardtype_from" id="forwardtype_from" label="В пункте отправления" style="width: 100%")
            option(v-for="item in forwardTypes" v-bind:key="item.id" v-bind:value="item.id") {{item.name}}

        .md-layout-item.md-size-40.center-layout
          z-select(v-model="forwardType.to" name="forwardtype_to" id="forwardtype_to" label="В пункте назначения" style="width: 100%")
            option(v-for="item in forwardTypes" v-bind:key="item.id" v-bind:value="item.id") {{item.name}}



        // Склады

        .md-layout-item.md-size-20.center-layout(v-show="parseInt(forwardType.from) == 1 || parseInt(forwardType.to) == 1")
          label Склады
        .md-layout-item.md-size-40.with-pr.center-layout(v-show="parseInt(forwardType.from) == 1 || parseInt(forwardType.to) == 1")
          z-select( v-show="parseInt(forwardType.from) == 1" v-model="stock.from" name="stock_from" id="stock_from" label="Склад отправления" style="width: 100%")
            option(v-bind:value="null") Любой
            option(v-for="stock in stocks" v-bind:key="stock.id" v-bind:value="stock.id") {{stock.name}}

        .md-layout-item.md-size-40.center-layout(v-show="parseInt(forwardType.from) == 1 || parseInt(forwardType.to) == 1")
          z-select( v-show="parseInt(forwardType.to) == 1" v-model="stock.to" name="stock_to" id="stock_to" label="Склад назначения" style="width: 100%")
            option(v-bind:value="null") Любой
            option(v-for="stock in stocks" v-bind:key="stock.id" v-bind:value="stock.id") {{stock.name}}




        // Населенные пункты

        .md-layout-item.md-size-20.center-layout(v-show="parseInt(forwardType.from) == 2 || parseInt(forwardType.to) == 2")
          label Населенные пункты
        .md-layout-item.md-size-40.with-pr.center-layout(v-show="parseInt(forwardType.from) == 2 || parseInt(forwardType.to) == 2")
          autocomplete(
              v-show="parseInt(forwardType.from) == 2"
              label="Населённый пункт отправления"
              display-property="value"
              property="value"
              return="value"
              v-model="city.from_value"
              v-bind:callback="getCities"
              v-bind:fixed="false"
              v-bind:default="city.from_value"
              v-validate="(city.from_value) ? 'required' : ''"
              :required="(city.from_value) ? true : false"

              id="deal_filter_city_from"
              name="deal_filter_city_from"
              v-bind:error="errors.first('deal_filter_city_from')"
              data-vv-name="deal_filter_city_from"
              v-bind:data-vv-as="' '"

              v-on:select="selectFromCity"
              v-on:clear="clearFromCity"
          )
        .md-layout-item.md-size-40.center-layout(v-show="parseInt(forwardType.from) == 2 || parseInt(forwardType.to) == 2")
          autocomplete(
              v-show="parseInt(forwardType.to) == 2"
              label="Населённый пункт назначения"
              display-property="value"
              property="value"
              return="value"
              v-model="city.to_value"
              v-bind:callback="getCities"
              v-bind:fixed="false"
              v-bind:default="city.to_value"

              v-validate="(city.to_value) ? 'required' : ''"
              :required="(city.to_value) ? true : false"

              id="deal_filter_city_to"
              name="deal_filter_city_to"
              v-bind:error="errors.first('deal_filter_city_to')"
              data-vv-name="deal_filter_city_to"
              v-bind:data-vv-as="' '"

              v-on:select="selectToCity"
              v-on:clear="clearToCity"
          )




        // Направления

        .md-layout-item.md-size-20.center-layout(v-show="parseInt(forwardType.from) == 3 || parseInt(forwardType.to) == 3")
          label Направления

        .md-layout-item.md-size-40.with-pr.center-layout(v-show="parseInt(forwardType.from) == 3 || parseInt(forwardType.to) == 3")
          autocomplete(
              v-show="parseInt(forwardType.from) == 3"
              label="Отправление"
              display-property="name"
              property="name"
              return="name"
              v-model="zone.from_value"
              v-bind:callback="getZone"
              v-bind:fixed="false"
              v-bind:default="zone.from_value"
              v-validate="(zone.from_value) ? 'required' : ''"
              :required="(zone.from_value) ? true : false"

              id="deal_filter_zone_from"
              name="deal_filter_zone_from"
              v-bind:error="errors.first('deal_filter_zone_from')"
              data-vv-name="deal_filter_zone_from"
              v-bind:data-vv-as="' '"

              v-on:select="selectFromZone"
              v-on:clear="clearFromZone"
          )
        .md-layout-item.md-size-40.center-layout(v-show="parseInt(forwardType.from) == 3 || parseInt(forwardType.to) == 3")
          autocomplete(
              v-show="parseInt(forwardType.to) == 3"
              label="Назначение"
              display-property="name"
              property="name"
              return="name"
              v-model="zone.to_value"
              v-bind:callback="getZone"
              v-bind:fixed="false"
              v-bind:default="zone.to_value"
              v-validate="(zone.to_value) ? 'required' : ''"
              :required="(zone.to_value) ? true : false"

              id="deal_filter_zone_to"
              name="deal_filter_zone_to"
              v-bind:error="errors.first('deal_filter_zone_to')"
              data-vv-name="deal_filter_zone_to"
              v-bind:data-vv-as="' '"

              v-on:select="selectToZone"
              v-on:clear="clearToZone"
          )





        // Адреса

        .md-layout-item.md-size-20.center-layout(v-show="parseInt(forwardType.from) == 4 || parseInt(forwardType.to) == 4")
          label Адреса

        .md-layout-item.md-size-40.with-pr.center-layout(v-show="parseInt(forwardType.from) == 4 || parseInt(forwardType.to) == 4")
          autocomplete(
              v-show="parseInt(forwardType.from) == 4"
              label="Отправление"
              display-property="value"
              property="value"
              return="value"
              v-model="address.from_value"
              v-bind:callback="getAddresses"
              v-bind:fixed="false"
              v-bind:default="address.from_value"

              v-validate="(address.from_value) ? 'required' : ''"
              :required="(address.from_value) ? true : false"

              id="deal_filter_address_from"
              name="deal_filter_address_from"
              v-bind:error="errors.first('deal_filter_address_from')"
              data-vv-name="deal_filter_address_from"
              v-bind:data-vv-as="' '"
              
              v-on:select="selectFromAddress"
              v-on:clear="clearFromAddress"
          )
        .md-layout-item.md-size-40.center-layout(v-show="parseInt(forwardType.from) == 4 || parseInt(forwardType.to) == 4")
          autocomplete(
              v-show="parseInt(forwardType.to) == 4"
              label="Назначение"
              display-property="value"
              property="value"
              return="value"
              v-model="address.to_value"
              v-bind:callback="getAddresses"
              v-bind:fixed="false"
              v-bind:default="address.to_value"

              v-validate="(address.to_value) ? 'required' : ''"
              :required="(address.to_value) ? true : false"

              id="deal_filter_address_to"
              name="deal_filter_address_to"
              v-bind:error="errors.first('deal_filter_address_to')"
              data-vv-name="deal_filter_address_to"
              v-bind:data-vv-as="' '"

              v-on:select="selectToAddress"
              v-on:clear="clearToAddress"
          )




        .md-layout-item.md-size-20.center-layout
          label Текущий склад
        .md-layout-item.md-size-80.center-layout
          //md-field(v-if="stocks && stocks.length")
            label(for="stock") Текущий склад
            md-select(v-model="stock" name="stock" id="stock")
              md-option(v-for="stock in stocks" v-bind:key="stock.id" v-bind:value="stock.id") {{stock.name}}
          z-select(v-model="current_stock" name="stock" id="stock" label="Текущий склад" style="width: 100%")
            option(v-bind:value="null") Любой
            option(v-for="stock in stocks" v-bind:key="stock.id" v-bind:value="stock.id") {{stock.name}}



        .md-layout-item.md-size-20.center-layout
          label Параметры груза
        .md-layout-item.with-pr.center-layout(style="width: calc((100% - 20%) / 3 - 15px); flex: auto;")
          md-field(v-bind:class="{'md-has-value': size.size}")
            label Объем
            md-input(v-model="size.size" name="freight_size" v-validate="'numeric'")
            span.md-error(v-show="errors.has('freight_size')") {{ errors.first('freight_size') }}
        
        .md-layout-item.with-pr.center-layout(style="width: calc((100% - 20%) / 3 - 15px); flex: auto;")
          md-field(v-bind:class="{'md-has-value': size.weight}")
            label Вес
            md-input(v-model="size.weight" name="freight_weight" v-validate="'numeric'")
            span.md-error(v-show="errors.has('freight_weight')") {{ errors.first('freight_weight') }}

        .md-layout-item.center-layout(style="width: calc((100% - 20%) / 3); flex: auto;")
          md-field(v-bind:class="{'md-has-value': size.seats}")
            label Количество мест
            md-input(v-model="size.seats" name="freight_seats" v-validate="'numeric'")
            span.md-error(v-show="errors.has('freight_seats')") {{ errors.first('freight_seats') }}

        .md-layout-item.md-size-20.center-layout
          label Температурный режим
        .md-layout-item.md-size-80
          md-switch(v-model="services" v-bind:value="22") Температурный режим

        //.md-layout-item.md-size-100
          .md-layout
            .md-layout-item.md-size-20
              label Связь с текущим складом
            .md-layout-item.md-size-80
              md-switch(v-model="onlyUserStocks") Да
              
        .md-layout-item.md-size-100
          .md-layout
            .md-layout-item.md-size-20.center-layout
              label Отправитель
            .md-layout-item.md-size-25.with-pr
              z-select(
                  label="Тип отправителя"
                  v-model="customers.from_type"
                  name="filter_sender_type"
                  id="filter_sender_type"
              )
                option(v-bind:value="null") Любой
                option(v-bind:value="1") Юридическое лицо
                option(v-bind:value="3") Индивидуальный предприниматель
                option(v-bind:value="2") Физическое лицо

            .md-layout-item.md-size-55(v-show="customers.from_type && ([1,3].indexOf(parseInt(customers.from_type))+1)")
              autocomplete(
                  label="Введите инн для поиска" v-bind:items="customersUL" v-model="customers.from_inn" v-bind:default="customers.from_inn"
                  v-bind:callback="searchCustomerByInn" 
                  display-property="ul_inn_label" property="inn" return="inn"
                  name="filter_sender_inn" id="filter_sender_inn"
              )
            .md-layout-item.md-size-55(v-show="customers.from_type && ([2].indexOf(parseInt(customers.from_type))+1)")
              autocomplete(
                  label="Введите номер паспорта для поиска" v-bind:items="customersUL" v-model="customers.from_passport" v-bind:default="customers.from_passport"
                  v-bind:callback="searchCustomerByPassport"
                  display-property="fl_passport_label" property="passport_number" return="passport_number"
                  name="filter_sender_passport" id="filter_sender_passport"
                  mask="99 99 999999"
              )


        .md-layout-item.md-size-100
          .md-layout
            .md-layout-item.md-size-20.center-layout
              label Получатель
            .md-layout-item.md-size-25.with-pr
              z-select(
                  label="Тип получателя"
                  v-model="customers.to_type"
                  name="filter_recipient_type"
                  id="filter_recipient_type"
              )
                option(v-bind:value="null") Любой
                option(v-bind:value="1") Юридическое лицо
                option(v-bind:value="3") Индивидуальный предприниматель
                option(v-bind:value="2") Физическое лицо
  
            .md-layout-item.md-size-55(v-show="customers.to_type && ([1,3].indexOf(parseInt(customers.to_type))+1)")
              autocomplete(
                  label="Введите инн для поиска" v-bind:items="customersUL" v-model="customers.to_inn" v-bind:default="customers.to_inn"
                  v-bind:callback="searchCustomerByInn" 
                  display-property="ul_inn_label" property="inn" return="inn"
                  name="filter_recipient_inn" id="filter_recipient_inn"
              )
            .md-layout-item.md-size-55(v-show="customers.to_type && ([2].indexOf(parseInt(customers.to_type))+1)")
              autocomplete(
                  label="Введите номер паспорта для поиска" v-bind:items="customersUL" v-model="customers.to_passport" v-bind:default="customers.to_passport"
                  v-bind:callback="searchCustomerByPassport"
                  display-property="fl_passport_label" property="passport_number" return="passport_number"
                  name="filter_recipient_passport" id="filter_recipient_passport"
                  mask="99 99 999999"
              )

        .md-layout-item.md-size-100
          .md-layout
            .md-layout-item.md-size-20.center-layout
              label Плательщик
            .md-layout-item.md-size-25.with-pr
              z-select(
                  label="Тип плательщика"
                  v-model="customers.payer_type"
                  name="filter_payer_type"
                  id="filter_payer_type"
              )
                option(v-bind:value="null") Любой
                option(v-bind:value="1") Юридическое лицо
                option(v-bind:value="3") Индивидуальный предприниматель
                option(v-bind:value="2") Физическое лицо

            .md-layout-item.md-size-55(v-show="customers.payer_type && ([1,3].indexOf(parseInt(customers.payer_type))+1)")
              autocomplete(
                  label="Введите инн для поиска" v-bind:items="customersUL" v-model="customers.payer_inn" v-bind:default="customers.payer_inn"
                  v-bind:callback="searchCustomerByInn" 
                  display-property="ul_inn_label" property="inn" return="inn"
                  name="filter_payer_inn" id="filter_payer_inn"
              )
            .md-layout-item.md-size-55(v-show="customers.payer_type && ([2].indexOf(parseInt(customers.payer_type))+1)")
              autocomplete(
                  label="Введите номер паспорта для поиска" v-bind:items="customersUL" v-model="customers.payer_passport" v-bind:default="customers.payer_passport"
                  v-bind:callback="searchCustomerByPassport"
                  display-property="fl_passport_label" property="passport_number" return="passport_number"
                  name="filter_payer_passport" id="filter_payer_passport"
                  mask="99 99 999999"
              )

        .md-layout-item.md-size-100
          .md-layout
            .md-layout-item.md-size-20.center-layout
              label Исполнитель (НДС)
            .md-layout-item.md-size-25.with-pr
              z-select(
                v-model="company_id"
                label="Исполнитель (НДС)"
                name="filter_company"
                id="filter_company"
              )
                option(v-bind:value="null") Любая
                option(
                  v-for="item in companies"
                  v-bind:key="`deals-search-company-${item.id}`"
                  v-bind:value="item.id"
                ) {{ ((parseInt(item.nds)) ? `с НДС ${item.nds_value}%` : 'без НДС') + ' (' + item.name + ')'}}

        .md-layout-item.md-size-100
          .md-layout
            .md-layout-item.md-size-20.center-layout
              label Способ оплаты
            .md-layout-item.md-size-25.with-pr
              multy-autocomplete(
                id="sender_contact"
                name="sender_contact"
                placeholder="Способ оплаты"
                display-property="name"
                property="id"
                return="id"
                v-model="payment_methods"
                v-bind:items="paymentMethods"
                v-bind:showOnFocus="true"
                v-bind:show-search-input="false"
                v-bind:return-all="false"
              )

        .md-layout-item.md-size-100
          .md-layout
            .md-layout-item.md-size-20.center-layout
              label Экспедирование
            .md-layout-item.md-size-25
              md-switch(v-model="forwarding.from") В пункте отправления
            .md-layout-item.md-size-25
              md-switch(v-model="forwarding.to") В пункте назначения
            .md-layout-item.md-size-30
              z-date(label="" placeholder="Дата экспедирования" v-model="forwarding.date" no-margin)


        .md-layout-item.md-size-100
          .md-layout
            .md-layout-item.md-size-20.center-layout
              label Наличие документов
            .md-layout-item.md-size-10
              md-switch(v-model="docs.bill") Счёт
            .md-layout-item.md-size-20
              md-switch(v-model="docs.invoice") Счёт фактура
            .md-layout-item.md-size-20
              md-switch(v-model="docs.receipt") Экспедиторская расписка
            .md-layout-item.md-size-10
              md-switch(v-model="docs.act") Акт
            .md-layout-item.md-size-20
              md-switch(v-model="docs.actp") Акт (принципал)

        .md-layout-item.md-size-100
          .md-layout
            .md-layout-item.md-size-20.center-layout
              label Отсутствие документов
            .md-layout-item.md-size-10
              md-switch(v-model="docs.nobill") Счёт
            .md-layout-item.md-size-20
              md-switch(v-model="docs.noinvoice") Счёт фактура
            .md-layout-item.md-size-20
              md-switch(v-model="docs.noreceipt") Экспедиторская расписка
            .md-layout-item.md-size-10
              md-switch(v-model="docs.noact") Акт

        .md-layout-item.md-size-100.md-alignment-bottom-right.dropdown-button-container
          md-button.md-dense.md-primary.small(v-on:click="customFilter")
            span(v-if="!dealsLoading") Применить
            div.deals-search-loader(v-if="dealsLoading")
              ZLoaderSpinner
              span Идёт загрузка
              
          //md-button.md-dense.md-accent.small(v-on:click="resetCustomFilter") Сбросить
            
  ul.dropdown.scrollable.md-elevation-2(v-if="showSearchDropdown && searchString")
    li.dropdown-item(v-on:click="filterByCustomer(customer)" v-for="customer in customersFilter") Контрагент #[md-chip {{ customer.name }}]
    li.dropdown-item(v-on:click="filterByResponsible(user)"  v-for="user in users") Ответственный #[md-chip {{ user.login }}]
    li.dropdown-item(v-on:click="filterByAddress(address)"   v-for="address in addresses") Адрес #[md-chip {{ address.address }}]
    //li(@click="filterByStatus(status)"     v-for="status in filteredStatuses") Статус #[md-chip {{ status.name }}]
    li.dropdown-item(v-on:click="filter") Поиск "{{ searchString }}"
</template>
<script>
  import ToggleMenu from '@/components/ToggleMenu'
  import MultyAutocomplete from '@/components/MultyAutocomplete';
  import autocomplete from '@/components/autocomplete'
  import ZSelect from '@/components/ZSelect'
  import ZDate from '@/components/ZDate'
  import ZLoaderSpinner from '@/components/ZLoaderSpinner'
  import ClickOutside from 'vue-click-outside'
  export default {
    components: { ToggleMenu, autocomplete, ZSelect, ZDate, ZLoaderSpinner, MultyAutocomplete },
    directives: { ClickOutside },
    data() {
      return {
        loading: false,
        filterSettings: false,
        searchString: '',
        showSearchDropdown: false,
        customersFilter: [],
        users: [],
        addresses: [],
        filteredStatuses: [],
        forwardTypes: [
          {id: 1, name: 'По складу'},
          {id: 2, name: 'По городу'},
          {id: 3, name: 'По направлению'},
          {id: 4, name: 'По точному адресу'},
        ],
        forwardType: {
          from: null,
          to: null
        },
        stock: {
          from: null,
          to: null
        },
        date: {
          from: null,
          to: null
        },
        city: {
          from: null,
          to: null,
          from_value: null,
          to_value: null
        },
        address: {
          from: null,
          to: null,
          from_value: null,
          to_value: null
        },
        zone: {
          from: null,
          from_value: null,
          to: null,
          to_value: null
        },
        forwarding: {
          from: false,
          to: false,
          date: null
        },
        docs: {
          bill:    false,
          invoice: false,
          receipt: false,
          act:     false,
          actp:    false,

          nobill:    false,
          noinvoice: false,
          noreceipt: false,
          noact:     false
        },
        size: {
          size: null,
          weight: null,
          seats: null
        },
        customers: {
          from_type: null,
          from_inn: null,
          from_passport: null,

          to_type: null,
          to_inn: null,
          to_passport: null,

          payer_type: null,
          payer_inn: null,
          payer_passport: null,
        },
        services: [],
        company_id: null,
        payment_methods: [],
        onlyUserStocks: null,
        current_stock: null,
        year: this.$cookie.get('filterDealsByYear') || this.moment().format('Y'),
        status: this.$cookie.get('filterDealsByStatus') || 'all',
        dealStatus: this.$cookie.get('filterDealsByDealStatus') || 'all',
      }
    },
    created() {
      this.getPaymentMethods();
      this.getCompanies();
      this.getStocks();
      this.setSearchString();
      this.$nextTick(() => {
        this.status     = (this.$cookie.get('filterDealsByStatus'))     ? this.$cookie.get('filterDealsByStatus')     : 'all';
        this.dealStatus = (this.$cookie.get('filterDealsByDealStatus')) ? this.$cookie.get('filterDealsByDealStatus') : 'all';

        if (this.$route.query && this.$route.query.custom_filter) {
          let filter = JSON.parse(this.$route.query.custom_filter);

          if (filter.date) {
            this.date.from = filter.date.from;
            this.date.to = filter.date.to;
          }
          if (filter.forwarding) this.forwarding = filter.forwarding;
          if (filter.docs) this.docs = filter.docs;
          if (filter.size) this.size = filter.size;

          if (filter.zone)       this.zone       = filter.zone;
          if (filter.city)       this.city       = filter.city;
          if (filter.stock)      this.stock      = filter.stock;
          if (filter.address)    this.address    = filter.address;
          if (filter.customers)  this.customers  = filter.customers;
          if (filter.company_id) this.company_id = filter.company_id;
          if (filter.payment_methods) this.payment_methods = filter.payment_methods;
          if (filter.services)   this.services   = filter.services;
          
          if (filter.current_stock) this.current_stock  = filter.current_stock;
          if (filter.user_stocks)   this.onlyUserStocks = true;
        } 
        
        /* //Ограничение для Представителей, сейчас перенесено на БЕ
        else if (this.isUserAgent && this.usersStocks) {
          this.onlyUserStocks = true;
          this.$router.push({ name: this.$route.name, params: this.$route.params, query: { custom_filter: JSON.stringify({
            user_stocks: (this.onlyUserStocks) ? this.usersStocks : null
          })}});
        }
        */
        this.$root.$emit('refresh-table', 'deals');
      });
    },
    computed: {
      years() {
        const years = [];
        let current = this.moment();
        while(current.format('Y') >= 2000) {
          years.push(current.format('Y'));
          current = current.subtract(1, 'year');
        }
        return years;
      },
      dealsLoading() {
          return this.$store.state.deals.dealsLoading;
      },
      dealStatuses() {
          return this.$store.state.deals.statusesall;
      },
      freightStatuses() {
        return this.$store.state.stock.freight_statuses;
      },
      hasCustomFilter() {
        return (this.$route.query && this.$route.query.custom_filter);
      },
      stocks() {
        if (!this.$store.state.stock.stocks || !this.$store.state.stock.stocks.length) return [];
        else return this.$store.state.stock.stocks;
      },
      companies() {
        if (!this.$store.state.companies.companies || !this.$store.state.companies.companies.length) return [];
        else return this.$store.state.companies.companies;
      },
      paymentMethods() {
        return this.$store.state.cost.payment_methods;
      },

      user() {
        return this.$store.state.users.current;
      },
      usersStocks() {
        return (this.user && this.user.stocks_id) ? this.user.stocks_id : [];
      },
      isUserAgent() {
        return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('agent')+1) : false;
      },

      customersUL() {
          let customers = this.$store.state.customers.customers_ul;
          if (!customers || !customers.data || !customers.data.length) return [];
          customers = customers.data;
          customers.map(item => {
              item.ul_inn_label = item.inn + ': ' + item.name;
              item.ul_name_label = item.name + ': ' + item.inn;
          });
          return customers;
      },
      customersFL() {
          let customers = this.$store.state.customers.customers_fl;
          if (!customers || !customers.data || !customers.data.length) return [];
          customers = customers.data;
          customers.map(item => {
              item.fl_passport_label = item.passport_number + ': ' + item.name;
              item.fl_name_label = item.name + ': ' + item.passport_number;
          });
          return customers;
      },

    },
    watch: {
      'forwardType.from'() {
        this.stock.from = null;
        this.clearFromCity();
        this.clearFromAddress();
        this.clearFromZone();
      },
      'forwardType.to'() {
        this.stock.to = null;
        this.clearToCity();
        this.clearToAddress();
        this.clearToZone();
      },
      'customers.from_type'() {
        this.customers.from_inn = null;
        this.customers.from_passport = null;
      },
      'customers.to_type'() {
        this.customers.to_inn = null;
        this.customers.to_passport = null;
      },
      'customers.payer_type'() {
        this.customers.payer_inn = null;
        this.customers.payer_passport = null;
      }
    },
    methods: { 
      toggleFilterSettings() {
        this.filterSettings = !this.filterSettings;
      },
      hideFilterSettings() {
        this.filterSettings = false;
      },
      //сброс фильтра
      resetFilter() {
        this.searchString = '';
        this.showSearchDropdown = false;
        this.resetCustomFilter();
      },
      //выпадашка фильтра
      dropdown() {
        if (this.loading || !this.searchString || `${this.searchString}`.length < 3) return;
        this.showSearchDropdown = true;
        this.loading = true;
        let PromArray = [];
        
        let filter = {model: [
            ["inn", "%", this.searchString], "or",
            ["passport_number", "%", this.searchString], "or",
            ["name", "%", this.searchString]
        ]};
        PromArray.push(this.$store.dispatch('customers/getCustomers', { filter: filter }).then(customers => {
          this.customersFilter = customers
        }));

        /*
        let userFilter = {model: [["login", "%", this.searchString]]};
        PromArray.push(this.$store.dispatch('users/searchUsers', { filter: userFilter }).then(users => {
          if (users && users.data && users.data.length) this.users = users.data;
        }));
        
        this.addresses = []; let findAddress = [];
        PromArray.push(this.$store.dispatch('deals/searchDeals', {
            count: 5, page: 1,
            filter: {
              model: ['traking_number', '%', this.searchString],
              relation: [
                ['firstFreight', 'traking_number', '%', this.searchString], 'or',
                ['fromAddress', 'address', '%', this.searchString], 'or'
                ['toAddress', 'address', '%', this.searchString],
              ]
          }
        }).then(deals => {
          if (deals && deals.length) {
            deals.map(deal => {
              if (deal.from_address && deal.from_address.id && !(findAddress.indexOf(deal.from_address.address)+1) && (deal.from_address.address.indexOf(this.searchString)+1)) {
                this.addresses.push(deal.from_address);
                findAddress.push(deal.from_address.address);
              }
              if (deal.to_address && deal.to_address.id && !(findAddress.indexOf(deal.to_address.address)+1) && (deal.to_address.address.indexOf(this.searchString)+1)) {
                this.addresses.push(deal.to_address);
                findAddress.push(deal.to_address.address);
              }
            });
          }
        }));
        */
        
        Promise.all(PromArray).finally(() => this.loading = false);

        //this.filteredStatuses = this.freightStatuses.filter(status => status.name.toLowerCase().search(this.searchString.toLowerCase()) == 0)
      },
      customFilter() {
        if (this.dealsLoading) return;
        this.filterSettings = false;
        this.$router.push({ name: this.$route.name, params: this.$route.params, query: { custom_filter: JSON.stringify({
            date: this.date,
            forwarding: this.forwarding,
            docs: this.docs,
            city: this.city,
            zone: this.zone,
            stock: this.stock,
            size: this.size,
            company_id: this.company_id,
            customers: this.customers,
            address: this.address,
            services: this.services,
            current_stock: this.current_stock,
            services: this.services,
            user_stocks: (this.onlyUserStocks) ? this.usersStocks : null,
            payment_methods: this.payment_methods ? this.payment_methods.map(i => i.id) : [],
          })}});
        this.$root.$emit('refresh-table', 'deals');
        this.$store.commit('deals/setDealFilter');
      },
      resetCustomFilter() {
        if (this.dealsLoading) return;
        this.filterSettings = false;
        this.current_stock  = null;
        this.services   = [];
        this.company_id = null;
        this.payment_methods = [];
        this.services   = [];
        this.date       = Object.assign({}, {from: null, to: null});
        this.forwarding = Object.assign({}, {from: false, to: false});
        this.docs       = Object.assign({}, {
          bill:    false,
          invoice: false,
          receipt: false,
          act:     false,
          actp:    false,
          nobill:    false,
          noinvoice: false,
          noreceipt: false,
          noact:     false
        });
        this.size       = Object.assign({}, {size: null, weight: null, seats: null});
        this.stock      = Object.assign({}, {from: null, to: null});
        this.customers  = Object.assign({}, {
          from_type: null, from_inn: null, from_passport: null, 
          to_type: null, to_inn: null, to_passport: null,
          payer_type: null, payer_type: null, payer_type: null,
        });

        this.clearFromCity();
        this.clearFromAddress();
        this.clearFromZone();
        this.clearToCity();
        this.clearToAddress();
        this.clearToZone();
        
        this.$router.push({ name: this.$route.name, params: this.$route.params, query: {}});
        this.$root.$emit('refresh-table', 'deals');  
        this.$store.commit('deals/unsetDealFilter');
      },
      //фильтр по ответственному
      filterByResponsible(user) {
        if (this.showSearchDropdown) {
          this.showSearchDropdown = false;
          this.$router.push({ name: this.$route.name, params: this.$route.params, query: { responsible_id: user.id, search_string: user.name}});
          this.$root.$emit('refresh-table', 'deals');
          this.setSearchString();
          this.$store.commit('deals/setDealFilter');
        }
      },
      //фильтр по контрагенту
      filterByCustomer(customer) {
        if (this.showSearchDropdown) {
          this.showSearchDropdown = false;
          this.$router.push({ name: this.$route.name, params: this.$route.params, query: { customer_id: customer.id, search_string: customer.name}});
          this.$root.$emit('refresh-table', 'deals');
          this.setSearchString();
          this.$store.commit('deals/setDealFilter');
        }
      },
      filterByAddress(address) {
          if (this.showSearchDropdown) {
              this.showSearchDropdown = false;
              this.$router.push({ name: this.$route.name, params: this.$route.params, query: { address_id: address.id, search_string: address.address}});
              this.$root.$emit('refresh-table', 'deals');
              this.setSearchString();
              this.$store.commit('deals/setDealFilter');
          }
      },
      //общий фильтр
      filter() {
        this.showSearchDropdown = false;
        this.$router.push({ name: this.$route.name, params: this.$route.params, query: { search: this.searchString }});
        this.$root.$emit('refresh-table', 'deals');
        this.setSearchString()
        this.$store.commit('deals/setDealFilter');
      },
      //инициализация строки поиска
      setSearchString() {
        if (this.$route.query.search) this.searchString = this.$route.query.search;
        else if (this.$route.query.search_string) this.searchString = this.$route.query.search_string;
      },
      //сохранение фильтра по статусу
      changeStatusFilter(status) {
        let query = Object.assign({}, this.$route.query);
        if (query && query.page) query.page = 1;
        this.status = status;
        this.$cookie.set('filterDealsByStatus', status, { expires: '1M' });
        this.$router.replace({ name: this.$route.name, params: this.$route.params, query: query});
        this.$root.$emit('refresh-table', 'deals');
        if (!status || status == 'all') this.$store.commit('deals/unsetDealFilter');
        else this.$store.commit('deals/setDealFilter');
      },
      changeDealStatusFilter(dealStatus) {
        let query = Object.assign({}, this.$route.query);
        if (query && query.page) query.page = 1;
        this.dealStatus = dealStatus;
        this.$cookie.set('filterDealsByDealStatus', dealStatus, { expires: '1M' });
        this.$router.replace({ name: this.$route.name, params: this.$route.params, query: query});
        this.$root.$emit('refresh-table', 'deals');
        if (!dealStatus || dealStatus == 'all') this.$store.commit('deals/unsetDealFilter');
        else this.$store.commit('deals/setDealFilter');
      },
      changeDealYearFilter(year) {
        let query = Object.assign({}, this.$route.query);
        if (query && query.page) query.page = 1;
        this.year = year;
        this.$cookie.set('filterDealsByYear', year, { expires: '1M' });
        this.$router.replace({ name: this.$route.name, params: this.$route.params, query: query});
        this.$root.$emit('refresh-table', 'deals');
      },
      

      searchCustomerByInn(inn) {
          if (!inn || (inn.length != 10 && inn.length != 12)) return new Promise((resolve, reject) => resolve([]));
          return this.$store.dispatch('customers/searchAndSuggestCustomers', {search: inn, type: 4}).then(customers => {
              if (customers && customers.data && Array.isArray(customers.data)) customers = Object.assign([], customers.data)
              if (!customers || !customers.length) return [];
              customers.map(item => {
                  item.ul_inn_label = item.inn + ': ' + item.name;
                  item.ul_name_label = item.name + ': ' + item.inn;
                  return item;
              });
              return customers;
          }, r => []);
      },
      searchCustomerByPassport(passport, type, input) {
          if (!passport || passport.replace(/\D/g, "").length != 10) return new Promise((resolve, reject) => resolve([]));
          return this.$store.dispatch('customers/searchCustomers', { search: passport, type: 2 }).then(customers => {
              if (customers && customers.data && Array.isArray(customers.data)) customers = Object.assign([], customers.data)
              if (!customers || !customers.length) return [];
              customers.map(item => {
                  item.fl_passport_label = (item.passport_number ? (item.passport_number + ': ') : '') + item.name;
                  item.fl_name_label = item.name + (item.passport_number ? (': ' + item.passport_number) : '');
                  return item;
              });
              return customers;
          }, r => []);
      },


      selectFromCity(value, city) {
        if (!city || !city.id) return;
        this.city.from = city.id;
      },
      selectToCity(value, city) {
        if (!city || !city.id) return;
        this.city.to = city.id;
      },
      clearFromCity() {
        this.city.from = null;
        this.city.from_value = null;
      },
      clearToCity() {
        this.city.to = null;
        this.city.to_value = null;
      },
      getCities(value) {
        let params = {
            page:       1,
            order_by:   'id',
            order_type: 'asc',
            count:      10,
            filter:     {model: [['name', '%', value], 'or', ['value', '%', value]], relation: []},
        };
        return this.$store.dispatch('cost/getCitiesNew', params).then(result => {
          let cities = [];
          if (result.data && result.data.length) result.data.map(item => {
            if (!item.value) item.value = item.name;
            cities.push(item);
          });
          return cities;
        });
      },
      
      
      selectFromAddress(value, address) {
        if (!address || !address.data.fias_id) return;
        this.address.from = address.data.fias_id;
      },
      selectToAddress(value, address) {
        if (!address || !address.data.fias_id) return;
        this.address.to = address.data.fias_id;
      },
      clearFromAddress() {
        this.address.from = null;
        this.address.from_value = null;
      },
      clearToAddress() {
        this.address.to = null;
        this.address.to_value = null;
      },
      getAddresses(value) {
        return this.$store.dispatch('deals/suggest', {string: value}).then(result => {
            return result;
        });
      },


      selectFromZone(value, zone) {
        if (!zone || !zone.id) return;
        this.zone.from = zone.id;
      },
      selectToZone(value, zone) {
        if (!zone || !zone.id) return;
        this.zone.to = zone.id;
      },
      clearFromZone() {
        this.zone.from = null;
        this.zone.from_value = null;
      },
      clearToZone() {
        this.zone.to = null;
        this.zone.to_value = null;
      },
      getZone(value) {
        return this.$store.dispatch('cost/suggestZones', value).then(r => {
          if (!r || !r.data) return [];
          return r.data;
        });
      },
      getStocks() { //получение всех складов
        return this.$store.dispatch('stock/getStocks', {
            page: 1, order_by: 'id', order_type: 'asc', count: 100, cache: true
        });
      },
      getCompanies() {
        return this.$store.dispatch('companies/getCompanies',{
          page: 1, order_by: 'id', order_type: 'asc', count: 100, cache: true
        })
      },
      getPaymentMethods() {
        this.$store.dispatch('cost/getPaymentMethods', {page: 1, order_by: 'id', order_type: 'asc', count: 100, cache: true, filter: {model: [['active', '=', 1]]}});
      },
    }
  }
</script>
<style lang="sass">
  .deals-search
    .deals-search__year
      min-width: 60px
    .z-select__input-container
      &::before,
      &::after
        //display: none
    .dropdown
      max-height: 90vh
      overflow: auto
    .dropdown-item
      .md-chip
        max-width: 100%
        text-overflow: ellipsis
        overflow: hidden
    .deals-search-loader
      display: flex
      align-items: center
      justify-items: flex-end
      gap: 10px

  .deals-search-setting
    max-height: 90vh
    max-width: 100%
    overflow: auto
    .filter-container
      width: 100%
      .center-layout
        display: flex
        align-items: center
        justify-content: flex-start
      .with-pr
        padding-right: 15px
</style>



// WEBPACK FOOTER //
// DealsToolbar.vue?35e0fad2